import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUserSettings, updateUserSettings } from './actions';
import { withTranslation } from 'react-i18next';
import UserSettingsForm from './SettingsForm';

class Profile extends Component {
	constructor(props) {
		super(props);
		this.handleUserSettingsSubmit = this.handleUserSettingsSubmit.bind(this);
	}

	componentDidMount() {
		this.props.fetchUserSettings();
	}

	handleUserSettingsSubmit(values) {
		const { systemAlertEvents, ...rest } = values;	// systemAlertEvents: { BookingCompolete: true, IndividualConsultationComplete: false, JoinWaitingList: true }
		const selectedEvents = Object.keys(systemAlertEvents).filter(eventName => systemAlertEvents[eventName] === true);

		this.props.updateUserSettings({
			systemAlertEvents: selectedEvents.length > 0 ? selectedEvents.join() : null,	// 'BookingComplete,JoinWaitingList'
			...rest
		});
	}

	render() {
		const { profile, systemAlertEventTypes } = this.props;
		const { loading, systemAlertEvents, ...rest } = profile;	// systemAlertEvents: 'BookingComplete,JoinWaitingList'

		const selectedEvents = {};
		if (systemAlertEvents) {
			systemAlertEvents.split(',').forEach(eventName => {
				if (eventName.trim()) {
					Object.assign(selectedEvents, { [eventName.trim()]: true });
				}
			});
		}

		const initialValues = {
			systemAlertEvents: selectedEvents,	// systemAlertEvents: { BookingComplete: true, JoinWaitingList: true }
			...rest
		};

		return <UserSettingsForm
			canConfigureSystemAlerts={profile.canConfigureSystemAlerts}
			onSubmit={this.handleUserSettingsSubmit}
			initialValues={initialValues}
			systemAlertEventTypes={systemAlertEventTypes} />;
	}
}

const mapStateToProps = state => ({
	profile: state.profile,
	systemAlertEventTypes: state.lookups.systemAlertEventTypes
});

export default connect(mapStateToProps, {
	fetchUserSettings,
	updateUserSettings
})(withTranslation()(Profile));